import React from "react";
import { useNavigate } from "react-router-dom";

/**
 * Header + breadcrumb for create (and similar) pages — matches list pages like Shift.
 * @param {React.ComponentType<{ className?: string }>} icon
 * @param {string} title
 * @param {string} description
 * @param {{ label: string, to?: string }[]} breadcrumbs — last item omit `to` for current page
 */
export default function PageCreateHeader({ icon: Icon, title, description, breadcrumbs }) {
  const navigate = useNavigate();

  return (
    <div className="bg-white shadow-lg rounded-2xl p-5 border border-gray-100 w-full min-w-0">
      <div className="flex items-center gap-3">
        <div className="p-3 bg-green-100 rounded-2xl shadow-inner">
          <Icon className="text-green-600 text-xl" />
        </div>
        <div>
          <h1 className="text-xl font-semibold text-gray-800">{title}</h1>
          <p className="text-gray-500 text-sm">{description}</p>
        </div>
      </div>

      <nav aria-label="Breadcrumb" className="mt-3 text-gray-500 text-sm">
        <ol className="flex items-center space-x-2 flex-wrap">
          {breadcrumbs.map((crumb, index) => (
            <React.Fragment key={`${crumb.label}-${index}`}>
              {index > 0 ? <li aria-hidden="true">/</li> : null}
              <li>
                {crumb.to != null ? (
                  <button
                    type="button"
                    onClick={() => navigate(crumb.to)}
                    className="hover:text-gray-700 transition"
                  >
                    {crumb.label}
                  </button>
                ) : (
                  <span className="text-gray-400">{crumb.label}</span>
                )}
              </li>
            </React.Fragment>
          ))}
        </ol>
      </nav>
    </div>
  );
}
